// extracted by css-extract-rspack-plugin
export default {"list":"FMwJtUzzVawYMIK5","listItem":"kDLaFzBZUacPH3FD"};